import {customAxios, IDUSUARIO, FDV_URL, USERNAME, GENERIC_URL, STOCK_URL} from '../constants';
import { FETCH_CONTACTOS_CLIENTES } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchContactosClientes(codigo,codCliente,codContacto,dirCorreo,indInactivo,nomContacto) {
    const data = {
        codCliente: codCliente===null?'':codCliente,
        codContacto: codContacto===null?'':codContacto,
        dirCorreo: dirCorreo===null?'':dirCorreo,
        indInactivo: indInactivo===null?'':indInactivo,
        nomContacto: nomContacto===null?'':nomContacto,
    };

    const config = {
        headers: {
            idUsuario: IDUSUARIO,
            codUsuario: USERNAME,
        },
    };


    const request = customAxios.post(`${FDV_URL}/ficha-venta/clientes/${codigo}/contactos-cliente`, data, config)
        .then(({ data }) => evalAction(data, 'adjuntar'))
        .catch(error => serverError(error, 'adjuntar'))



    return {
        type: FETCH_CONTACTOS_CLIENTES,
        payload: request,
    };
}

/*REQ-86298*/

export function fetchObtenerClientes(cadena, ruc, dni, codCliente, numPag, cantiRegPag){


    let config2;
    if (numPag === null) {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: '1',
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    } else {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: numPag,
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    }

    const data = {
        cadena: cadena === null ? '' : cadena,
        codcliente: codCliente === null ? '' : codCliente,
        dni: dni === null ? '' : dni,
        ruc: ruc === null ? '' : ruc
    };
    /*const config = {
        headers: {
            idUsuario: IDUSUARIO,
            codUsuario: USERNAME,
            numPag: numPag.length ? numPag : '1',
            cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
        },
    };*/

    const request = customAxios.post(`${GENERIC_URL}/cliente/listar`, data, config2)
        .then(({data}) => evalAction(data, 'adjuntar'))
        .catch(error => serverError(error, 'adjuntar'));

    return {
        type: 'FETCH_CLIENTES',
        payload: request,
    };
}

export function fetchobtenerAsesor(codVendedor,nombreVendedor, numPag, cantiRegPag) {

    const data = {
        codVendedor: codVendedor === null ? '' : codVendedor,
        nombreVendedor: nombreVendedor === null ? '' : nombreVendedor
    };

    /* const config = {
         headers: {
             idUsuario: IDUSUARIO,
             codUsuario: USERNAME,
             numPag: numPag.length ? numPag : '1',
             cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
         }
     };*/
    let config2;
    if (numPag === null) {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: '1',
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    } else {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: numPag,
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    }

    const request = customAxios.post(`${GENERIC_URL}/vendedor/accesoConsultaListar`, data, config2)
        .then(({data}) => evalAction(data, 'adjuntar'))
        .catch(error => serverError(error, 'adjuntar'));

    return {
        type: 'FETCH_ASESORES',
        payload: request,
    };
}

export function fetchObtenerModelo(codModelo, descModelo, numPag, cantiRegPag) {

    const data = {
        codModelo: codModelo === null ? '' : codModelo,
        descModelo: descModelo === null ? '' : descModelo
    };

    /*const config = {
        headers: {
            idUsuario: IDUSUARIO,
            codUsuario: USERNAME,
            numPag: numPag.length ? numPag : '1',
            cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
        }
    };*/
    let config2;
    if (numPag === null) {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: '1',
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    } else {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: numPag,
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    }

    const request = customAxios.post(`${STOCK_URL}/maestros/modeloVeh/accesoProformaListar`, data, config2)
        .then(({data}) => evalAction(data, 'adjuntar'))
        .catch(error => serverError(error, 'adjuntar'));

    return {
        type: 'FETCH_MODELOS',
        payload: request,
    };
}

export function fetchObtenerConfiguracion(desConfigVeh, skuSap,  numPag, cantiRegPag) {

    const data = {
        desConfigVeh: desConfigVeh === null ? '' : desConfigVeh,
        skuSap: skuSap === null ? '' : skuSap
    };

    /*const config = {
        headers: {
            idUsuario: IDUSUARIO,
            codUsuario: USERNAME,
            numPag: numPag.length ? numPag : '1',
            cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
        }
    };*/
    let config2;
    if (numPag === null) {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: '1',
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    } else {
        config2 = {
            headers: {
                idUsuario: IDUSUARIO,
                codUsuario: USERNAME,
                numPag: numPag,
                cantiRegPag: cantiRegPag.length ? cantiRegPag : '10',
            },
        };
    }

    const request = customAxios.post(`${STOCK_URL}/maestros/configuracionVeh/listar`, data, config2)
        .then(({data}) => evalAction(data, 'adjuntar'))
        .catch(error => serverError(error, 'adjuntar'));

    return {
        type: 'FETCH_CONFIGURACION',
        payload: request,
    };
}
/*REQ-86298*/



// WEBPACK FOOTER //
// ./src/actions/ContactosClientesFacturacion.js